"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingUploadDTO = exports.PendingUploadDTOSchema = void 0;
var zod_1 = require("zod");
// Main PendingUpload schema with embedded user
exports.PendingUploadDTOSchema = zod_1.z.object({
    _id: zod_1.z.string(),
    Status: zod_1.z.string(),
    Expiry: zod_1.z.date(),
    Name: zod_1.z.string(),
    UploadUrl: zod_1.z.string(),
    AuthorId: zod_1.z.string(),
    UserId: zod_1.z.string(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
    user: zod_1.z
        .object({
        _id: zod_1.z.string(),
        fullName: zod_1.z.string(),
        image: zod_1.z.string(),
    })
        .optional(),
});
// DTO conversion object
exports.PendingUploadDTO = {
    convertFromModel: function (model) {
        return {
            _id: model._id,
            Status: model.Status,
            Expiry: new Date(model.Expiry),
            Name: model.Name,
            UploadUrl: model.UploadUrl,
            AuthorId: model.AuthorId,
            UserId: model.UserId,
            createdAt: new Date(model.createdAt),
            updatedAt: new Date(model.updatedAt),
            user: model.user
                ? {
                    _id: model.user._id,
                    fullName: model.user.fullName,
                    image: model.user.image,
                }
                : undefined,
        };
    },
};
//# sourceMappingURL=PendingUpload.js.map